import Box from '@mui/material/Box';
import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import {config} from '../../../common/config/config';
import Paper from '@mui/material/Paper';
import {
    constance,
} from '../../../common/constance/constance';
import {common} from '../../../common/common';
import {styles} from '../../../common/style';
import {isMobile} from 'react-device-detect';
import {useNavigate} from 'react-router-dom';
import {PostInterface} from '../../../interface/post.interface';
import {MenuInterface} from "../../../interface/menu.interface";

export default function PostShareListTable(props: { postList: PostInterface[], menu: MenuInterface }) {
    console.log('[PostShareListTable]');
    const navigate = useNavigate();

    let {id, workplace, no} = common.getQuery();

    function movePostList(post: PostInterface) {
        navigate(`${config.url.postView}?id=${id}&no=${post.no}&workplace=${workplace}`);
    }

    let fontSize: any = isMobile? "subtitle2" :"subtitle1";

    return (
        <React.Fragment>
            <Box sx={{display: 'flex', justifyContent: 'center', p: 1}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', mb: 2,
                }}>
                    {
                        props.postList.map((post, index) => {
                            return (
                                <Paper key={index}
                                       onClick={() => movePostList(post)}
                                       variant={'elevation'}
                                       elevation={3}
                                       sx={{
                                           display: 'flex', alignItems: 'flex-start',
                                           transition: 'all ease-out 0.3s',
                                           ': hover': {
                                               background: 'var(--scc-card-hover)',
                                           },
                                           cursor: 'pointer',
                                           mt: isMobile ? 1 : 3, width: 1, p: isMobile ? 1 : 2, pl: isMobile ? 1 : 4,
                                       }}>
                                    <Stack sx={{width: isMobile ? 0.5 : 0.6, pr: isMobile ? 1 : 4}}>
                                        <Typography variant={isMobile ? 'h6' : 'h4'}
                                                    sx={{color: styles.fontColor.secondary, fontWeight: 700}}>
                                            {`[${constance.workplaceNameMap[post.workplace]}] ${post.title}`}
                                        </Typography>
                                        {/* 타이틀 */}
                                        <Box sx={{width: 1, display: 'flex', mt: isMobile ? 2 : 4}}>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{
                                                            color: styles.fontColor.main,
                                                            fontWeight: 500,
                                                            width: 0.25
                                                        }}>
                                                {`상태`}
                                            </Typography>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{
                                                            color: post.shareStatus == 0 ? 'red' : styles.fontColor.secondary,
                                                            width: 0.75
                                                        }}>
                                                {post.shareStatus == 0 ? '나눔 중' : '나눔 완료'}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{mt: isMobile ? 1 : 2, mb: isMobile ? 1 : 2}}/>
                                        {/* 수량 */}
                                        <Box sx={{width: 1, display: 'flex'}}>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{
                                                            color: styles.fontColor.main,
                                                            fontWeight: 500,
                                                            width: 0.25
                                                        }}>
                                                {`수량`}
                                            </Typography>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{color: styles.fontColor.secondary, width: 0.75}}>
                                                {post.amount}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{mt: isMobile ? 1 : 2, mb: isMobile ? 1 : 2}}/>

                                        {/* 등록일 */}
                                        <Box sx={{width: 1, display: 'flex'}}>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{
                                                            color: styles.fontColor.main,
                                                            fontWeight: 500,
                                                            width: 0.25
                                                        }}>
                                                {`등록일`}
                                            </Typography>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{color: styles.fontColor.secondary, width: 0.75}}>
                                                {common.getTimeFormat(post.createdAt)}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{mt: isMobile ? 1 : 2, mb: isMobile ? 1 : 2}}/>

                                        <Box sx={{width: 1, display: 'flex'}}>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{
                                                            color: styles.fontColor.main,
                                                            fontWeight: 500,
                                                            width: 0.25
                                                        }}>
                                                {`등록자`}
                                            </Typography>
                                            <Typography variant={isMobile ? 'subtitle2' : 'h6'}
                                                        sx={{color: styles.fontColor.secondary, width: 0.75}}>
                                                {`${post.user.departmentName} ${post.user.name}`}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{mt: isMobile ? 1 : 2, mb: isMobile ? 1 : 2}}/>

                                    </Stack>
                                    <Box sx={{
                                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                                        width: isMobile ? 0.5 : 0.4, height: 1,
                                        p: isMobile ? 1 : 2,
                                    }}>
                                        <img alt={''}
                                             style={{
                                                 maxHeight: 250,
                                                 maxWidth: '100%',
                                                 boxShadow: '2px 2px 2px #b5b5b5',
                                                 borderRadius: '12px',
                                             }}
                                             src={`${post.thumbnail}`}/>
                                    </Box>
                                </Paper>
                            );
                        })
                    }
                </Stack>
            </Box>

        </React.Fragment>
    );
}
